__turbopack_context__.v({
  "lineHeightLoose": "Xtwa_G_lineHeightLoose",
  "lineHeightNormal": "Xtwa_G_lineHeightNormal",
  "lineHeightRelaxed": "Xtwa_G_lineHeightRelaxed",
  "lineHeightSnug": "Xtwa_G_lineHeightSnug",
  "lineHeightTight": "Xtwa_G_lineHeightTight",
  "title": "Xtwa_G_title",
  "titleL": "Xtwa_G_titleL",
  "titleM": "Xtwa_G_titleM",
  "titleS": "Xtwa_G_titleS",
  "titleXL": "Xtwa_G_titleXL",
  "titleXS": "Xtwa_G_titleXS",
  "titleXXL": "Xtwa_G_titleXXL",
  "titleXXS": "Xtwa_G_titleXXS",
});
